import type { FC } from 'react';
import classNames from 'classnames';
import { ICollectOptionListItem } from '@/utils/ctype';
import HtmlParser from '../HtmlParser';
import style from './index.module.less';


export interface BoxProps {
  titleKey: string;
  dataKey: string;
  optionClass?: string;
  data: ICollectOptionListItem;
}

const Box: FC<BoxProps> =function Box(props) {
  const {data, optionClass, dataKey, titleKey} = props;

  return (
    <div data-testid="box" className={classNames(style.option, optionClass|| '', style.disable)} >
      <span data-key={titleKey} className={style.letter}><HtmlParser htmlString={data.titleHtml || data.title}></HtmlParser></span>
      <span data-key={dataKey}><HtmlParser htmlString={data.content}></HtmlParser></span>
    </div>
  );
};

export default Box;